export enum CaseType {
	S = 'S',
	C = 'C',
}

export enum EntityType {
	SUB_CASE = 'SubCase',
	CASE = 'Case',
}
